/**
 * 旅行独有埋点逻辑实现 WAP 版
 * @author shuke.cl <shuke.cl@taobao.com>
 *
 *
 **/

(function () {

    var win = window,
        doc = document;
    /**
     * 简单的AOP实现
     * @param obj
     * @param method
     * @param fn
     */
    function before(obj,method,fn){
        obj["$$_" + method] = obj[method];
        obj[method] = function(){
            fn.apply(obj,arguments);
            obj["$$_" + method].apply(obj,arguments);
        }
    }

    /**
     * 引入 js 文件
     * @param src
     */
    function importScript (src) {
        var d = doc.createElement("script");
        d.type = "text/javascript";
        d.async = true;
        d.src = src;
        doc.getElementsByTagName("head")[0].appendChild(d);
    }

    /**
     * 引入安全拦截脚本 @踊跃 @佳宸
     * @param n
     */
    (function () {
        if (doc.readyState === "complete") {
            // 如果页面已经加载完成，直接执行函数
            importScript("//g.alicdn.com/secdev/sufei_data/index.js");
        }
        else {
            win.addEventListener("load", function () {
                importScript("//g.alicdn.com/secdev/sufei_data/index.js");
            }, false);
        }
    })();

})();



/*****************
 ** WEBPACK FOOTER
 ** ./components/wlog/src/alitrip_wap.js
 ** module id = 18
 ** module chunks = 0
 **/